/* eslint-disable max-lines */
import { EcsProjectTeamName } from '../types';

export enum Experiment {
  AdminTenantSettingsRelayOverhaul = 'AdminTenantSettingsRelayOverhaul',
  AdminMuteUser = 'AdminMuteUser',
  AnswerCommunityClientSupportsQuestionTitle = 'AnswerCommunityClientSupportsQuestionTitle',
  AnswerCommunitySearchUX = 'AnswerCommunitySearchUX',
  AnswersAdminAIFeaturesToggle = 'AnswersAdminAIFeaturesToggle',
  AnswersAISuggestedCommunities = 'AnswersAISuggestedCommunities',
  AnswersAISuggestedTopics = 'AnswersAISuggestedTopics',
  AnswersCommunityAISuggestedTopics = 'AnswersCommunityAISuggestedTopics',
  AnswersCommunityEnablement = 'AnswersCommunityEnablement',
  AnswersCommunityForAll = 'AnswersCommunityForAll',
  AnswersDefaultRoutingInHomeFeed = 'AnswersDefaultRoutingInHomeFeed',
  AnswersDismissTopicSuggestion = 'AnswersDismissTopicSuggestion',
  AnswersForager = 'AnswersForager',
  AnswersGrowthPublisherQuestionPrompt = 'AnswersGrowthPublisherQuestionPrompt',
  AnswersInlineExpansion = 'AnswersInlineExpansion',
  AnswersInEngageTopics = 'AnswersInEngageTopics',
  AnswersInVivaGA = 'AnswersInVivaGA',
  AnswersMoreForYouQuestions = 'AnswersMoreForYouQuestions',
  AnswersNewPill = 'AnswersNewPill',
  AnswersOnboarding = 'AnswersOnboarding',
  AnswersOnlyMode = 'AnswersOnlyMode',
  AnswersPostGAExperience = 'AnswersPostGAExperience',
  AnswersPublisherWithCopilot = 'AnswersPublisherWithCopilot',
  AnswersTopicManagementPainPoints = 'AnswersTopicManagementPainPoints',
  AnswersTopicPickerAlignment = 'AnswersTopicPickerAlignment',
  AnswersUpdates = 'AnswersUpdates',
  ArticleCreationFlow = 'ArticleCreationFlow',
  ArticleOpenSameWindow = 'ArticleOpenSameWindow',
  ArticlePublisherWithCopilot = 'ArticlePublisherWithCopilot',
  ArticleViewMenu = 'ArticleViewMenu',
  ArticleWithLeftNav = 'ArticleWithLeftNav',
  AtMentionCustomName = 'AtMentionCustomName',
  AutoSuggestionCampaignHashtag = 'AutoSuggestionCampaignHashtag',
  BackButton = 'BackButton',
  BackendGraphqlApiVnextEndpoint = 'BackendGraphqlApiVnextEndpoint',
  BackendGraphQLApiVNextRolloutAlpha = 'BackendGraphQLApiVNextRolloutAlpha',
  BackendGraphQLApiVNextRolloutBeta = 'BackendGraphQLApiVNextRolloutBeta',
  BackendGraphQLApiVNextRolloutCanary = 'BackendGraphQLApiVNextRolloutCanary',
  BackendGraphQLApiVNextRolloutDogfood = 'BackendGraphQLApiVNextRolloutDogfood',
  BackendGraphQLApiVNextRolloutProd25 = 'BackendGraphQLApiVNextRolloutProd25',
  BackendGraphQLApiVNextRolloutProd50 = 'BackendGraphQLApiVNextRolloutProd50',
  BackendGraphQLApiVNextRolloutProd100 = 'BackendGraphQLApiVNextRolloutProd100',
  BackendLiveEventFeedCaching = 'BackendLiveEventFeedCaching',
  BackendLiveEventFeedCachingByTenant = 'BackendLiveEventFeedCachingByTenant',
  BackendOcularCosmos = 'BackendOcularCosmos',
  BackendStreamieCosmos = 'BackendStreamieCosmos',
  BenchmarkingInsights = 'BenchmarkingInsights',
  BellPageSize = 'BellPageSize',
  BespokeCommunityCreateEdit = 'BespokeCommunityCreateEdit',
  BookmarkThread = 'BookmarkThread',
  BulkRemoveTopicsInEngageAndAnswers = 'BulkRemoveTopicsInEngageAndAnswers',
  CampaignPrivateMessage = 'CampaignPrivateMessage',
  CampaignPublisherWithCopilot = 'CampaignPublisherWithCopilot',
  CampaignSashAvatar = 'CampaignSashAvatar',
  CampaignsCoOrganizers = 'CampaignsCoOrganizers',
  CampaignSearch = 'CampaignSearch',
  CampaignSearchImprovements = 'CampaignSearchImprovements',
  CampaignExecutiveSponsorRefinement = 'CampaignExecutiveSponsorRefinement',
  CampaignsExecutiveSponsorship = 'CampaignsExecutiveSponsorship',
  CampaignsHub = 'CampaignsHub',
  CampaignHoverCard = 'CampaignHoverCard',
  CampaignFollowerDetails = 'CampaignFollowerDetails',
  CardPresentationOnSearchTabs = 'CardPresentationOnSearchTabs',
  CoachingAtMentionInAnswers = 'CoachingAtMentionInAnswers',
  CoachingInsights = 'CoachingInsights',
  CommunityAma = 'CommunityAma',
  CommunityBadgeAdmin = 'CommunityBadgeAdmin',
  CommunityCampaigns = 'CommunityCampaigns',
  CommunityCoachTips = 'CommunityCoachTips',
  CommunityExperts = 'CommunityExperts',
  CommunityFeatureConversation = 'CommunityFeatureConversation',
  CommunityInsightsV2 = 'CommunityInsightsV2',
  CommunityInsightsV2Optimization = 'CommunityInsightsV2Optimization',
  CommunityInsightsV2ThreadMetrics = 'CommunityInsightsV2ThreadMetrics',
  CommunityLeads = 'CommunityLeads',
  CommunityLeadsAndAutoPin = 'CommunityLeadsAndAutoPin',
  CommunityManagerSubscriptionTip = 'CommunityManagerSubscriptionTip',
  CommunityMultiPinThreads = 'CommunityMultiPinThreads',
  CommunityPublisherWithCopilot = 'CommunityPublisherWithCopilot',
  CommunityQuestionThreadUpdate = 'CommunityQuestionThreadUpdate',
  CommunitySettingsPage = 'CommunitySettingsPage',
  CommunitySetupTeachingBubbles = 'CommunitySetupTeachingBubbles',
  CommunitySubscriptionBubbleOnly = 'CommunitySubscriptionBubbleOnly',
  CommunityTopQuestions = 'CommunityTopQuestions',
  CompactHeaderCommunities = 'CompactHeaderCommunities',
  CompactHeaderGeneral = 'CompactHeaderGeneral',
  CompactHeaderStoryline = 'CompactHeaderStoryline',
  CompanyLogoInLCHeader = 'CompanyLogoInLCHeader',
  CampaignAnalyticsWithSearch = 'CampaignAnalyticsWithSearch',
  CampaignEngageDigest = 'CampaignEngageDigest',
  CampaignTargeting = 'CampaignTargeting',
  CampaignTargetingV2 = 'CampaignTargetingV2',
  CondensedQuestionFeed = 'CondensedQuestionFeed',
  ConversationInsightsV2 = 'ConversationInsightsV2',
  ConversationInsightsV2ThemeSummarization = 'ConversationInsightsV2ThemeSummarization',
  CopyReactions = 'CopyReactions',
  CopilotCommunityConversion = 'CopilotCommunityConversion',
  CSVUploadGroupMembers = 'CSVUploadGroupMembers',
  DeprecatePostCommunityEmail = 'DeprecatePostCommunityEmail',
  DisablePollPostType = 'DisablePollPostType',
  DiscoverCommunitiesV2 = 'DiscoverCommunitiesV2',
  DiscoverOfficialCommunities = 'DiscoverOfficialCommunities',
  DiscoverTopicPageImprovements = 'DiscoverTopicPageImprovements',
  DivisionalBespokeCommunity = 'DivisionalBespokeCommunity',
  DomainMigration = 'DomainMigration',
  DraftSorting = 'DraftSorting',
  DraftPublisherWithCopilot = 'DraftPublisherWithCopilot',
  EmbedMsal = 'EmbedMsal',
  EmbedSupportForNetworkContext = 'EmbedSupportForNetworkContext',
  EnhancedDigestDiscoveryDesign = 'EnhancedDigestDiscoveryDesign',
  ExpandedReactionsEnabled = 'ExpandedReactionsEnabled',
  ExternalNetworksInGlammer = 'ExternalNetworksInGlammer',
  FAQIfy = 'FAQIfy',
  FAQIfyAnswersCommunity = 'FAQIfyAnswersCommunity',
  FavoritesDragDropReorder = 'FavoritesDragDropReorder',
  FollowButtonHomeFeedThreadWithGreyColor = 'FollowButtonHomeFeedThreadWithGreyColor',
  Fluent9Toolbar = 'Fluent9Toolbar',
  GroupFeedFilterAndSortByExp = 'GroupFeedFilterAndSortByExp',
  GroupHoverCardV2 = 'GroupHoverCardV2',
  GroupsFromGrouper = 'GroupsFromGrouper',
  HomeFollowingFeed = 'HomeFollowingFeed',
  HydrateAnswersTopicsAsync = 'HydrateAnswersTopicsAsync',
  InFeedUserSuggestions = 'InFeedUserSuggestions',
  InformationBarriersPhase0 = 'InformationBarriersPhase0',
  KnowledgeBespokeCommunity = 'KnowledgeBespokeCommunity',
  KnowledgeCommunitiesUnansweredFeed = 'KnowledgeCommunitiesUnansweredFeed',
  LeaderAudienceFeed = 'LeaderAudienceFeed',
  LeaderDashboard = 'LeaderDashboard',
  LeaderGroupsAddAsync = 'LeaderGroupsAddAsync',
  LeaderIdentificationFRE = 'LeaderIdentificationFRE',
  LeaderIDSmartEntryPoints = 'LeaderIDSmartEntryPoints',
  LeaderManagementActivityLog = 'LeaderManagementActivityLog',
  LeaderOptionWebpart = 'LeaderOptionWebpart',
  LeadersAudienceM365Support = 'LeadersAudienceM365Support',
  LeadershipCornerPinnedPosts = 'LeadershipCornerPinnedPosts',
  LightboxFollowUsers = 'LightboxFollowUsers',
  LimitConversationMoveSettingsAndFilter = 'LimitConversationMoveSettingsAndFilter',
  LogProtobufEvents = 'LogProtobufEvents',
  LongFormContentArticlePublisher = 'LongFormContentArticlePublisher',
  LongFormContentArticleView = 'LongFormContentArticleView',
  M365CopilotAdoption = 'M365CopilotAdoption',
  M365CopilotAdoptionContentStarters = 'M365CopilotAdoptionContentStarters',
  M365CopilotAdoptionSuggestedMembers = 'M365CopilotAdoptionSuggestedMembers',
  M365CopilotAdoptionTopQuestions = 'M365CopilotAdoptionTopQuestions',
  MediaPostStorylinePostMSIT = 'MediaPostStorylinePostMSIT',
  MicrosoftDesignerApp = 'MicrosoftDesignerApp',
  MinimalWFPayloadOnReplyPosting = 'MinimalWFPayloadOnReplyPosting',
  MessagesReactionsAPI = 'MessagesReactionsAPI',
  MobileCrossSellThreadViewV2 = 'MobileCrossSellThreadViewV2',
  MoveTopicSettings = 'MoveTopicSettings',
  MTOAdminToggle = 'MTOAdminToggle',
  MTOBadge = 'MTOBadge',
  MTOBlendedInbox = 'MTOBlendedInbox',
  MTOCampaigns = 'MTOCampaigns',
  MTOCommunity = 'MTOCommunity',
  MTOConversationsSearch = 'MTOConversationsSearch',
  MTOGraphVNextResolvers = 'MTOGraphVNextResolvers',
  MTOLeader = 'MTOLeader',
  MTOOpenResourceUrl = 'MTOOpenResourceUrl',
  MTOPolicyEngageAdminPortalPage = 'MTOPolicyEngageAdminPortalPage',
  MTOStoryline = 'MTOStoryline',
  MTOTeamsMeeting = 'MTOTeamsMeeting',
  EnablePermalinkDeeplink = 'EnablePermalinkDeeplink',
  MultiTenantOrganization = `MultiTenantOrganization`,
  MyGroupsAdminOfFilter = 'MyGroupsAdminOfFilter',
  NestedBestReply = 'NestedBestReply',
  NetworkQuestionsInConversations = 'NetworkQuestionsInConversations',
  NoWFMessageBodyInGroupMessageCreationResponse = 'NoWFMessageBodyInGroupMessageCreationResponse',
  OauthTokenExpires = 'OauthTokenExpires',
  OdspFilePickerType = 'OdspFilePickerType',
  OfficeTopics = 'OfficeTopics',
  OnboardingBannerInAnswersDigestEmail = 'OnboardingBannerInAnswersDigestEmail',
  OneCameraV3 = 'OneCameraV3',
  OnePlayerNative = 'OnePlayerNative',
  OpenPublisherWithCopilotModal = 'OpenPublisherWithCopilotModal',
  OptimizedReactionsFetching = 'OptimizedReactionsFetching',
  OutlookAnswersDigestBanner = 'OutlookAnswersDigestBanner',
  OWAEngageDigestLeaderAnalytics = 'OWAEngageDigestLeaderAnalytics',
  OWALoadTopicsSeparatelyFromThreadList = 'OWALoadTopicsSeparatelyFromThreadList',
  OWAMoreForYouReduction = 'OWAMoreForYouReduction',
  PageThreadHomeFeed = 'PageThreadHomeFeed',
  PeopleSuggestion3SV3 = 'PeopleSuggestion3SV3',
  PinnedFiles = 'PinnedFiles',
  PolicyReminderRedesignRRv2 = 'PolicyReminderRedesignRRv2',
  PollsSchedule = 'PollsSchedule',
  PostOnBehalfOfCommunityHomePublisher = 'PostOnBehalfOfCommunityHomePublisher',
  PostQuestionUpsellBetweenSearchResults = 'PostQuestionUpsellBetweenSearchResults',
  PrefilledDefaultAudience = 'PrefilledDefaultAudience',
  PreloadFeedAfterUserData = 'PreloadFeedAfterUserData',
  PrivateReplies = 'PrivateReplies',
  PrivateRepliesEditThreadStarter = 'PrivateRepliesEditThreadStarter',
  PublisherAbandonmentOCVSurvey = 'PublisherAbandonmentOCVSurvey',
  PublisherQuestionCoachingTip = 'PublisherQuestionCoachingTip',
  PublisherSuggestedTopics = 'PublisherSuggestedTopics',
  PublisherEmojiPicker = 'PublisherEmojiPicker',
  PWALegacyBrokenExperience = 'PWALegacyBrokenExperience',
  PWALegacyDeprecation = 'PWALegacyDeprecation',
  QuestionsQueue = 'QuestionsQueue',
  QuestionTitles = 'QuestionTitles',
  QuestionTitlesV2 = 'QuestionTitlesV2',
  QuickNavManageMyThings = 'QuickNavManageMyThings',
  ReactionSimplification = 'ReactionSimplification',
  ReadOnlyMode = 'ReadOnlyMode',
  RecommendationBarCampaignFollowBtn = 'RecommendationBarCampaignFollowBtn',
  RemovePublishButtonInDismissedFeed = 'RemovePublishButtonInDismissedFeed',
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds = 'RemoveTopicsSDKDependencyForVivaTopicsInFeeds',
  RemoveTopicsSDKForVivaTopicsInFeeds = 'RemoveTopicsSDKForVivaTopicsInFeeds',
  RestrictedUser = 'RestrictedUser',
  RestrictPostingAnyGroupRollout = 'RestrictPostingAnyGroupRollout',
  RoleBasedFRE = 'RoleBasedFRE',
  SearchAutoGroupScopeDisabled = 'SearchAutoGroupScopeDisabled',
  SearchDiscoverabilityFRE = 'SearchDiscoverabilityFRE',
  SearchPeopleInConversationFilter = 'SearchPeopleInConversationFilter',
  SearchThreadStarterSenderFilter = 'SearchThreadStarterSenderFilter',
  SearchPostTypeFilter = 'SearchPostTypeFilter',
  ServerSharePointWebLinks = 'ServerSharePointWebLinks',
  ShareAMAPoboToStoryline = 'ShareAMAPoboToStoryline',
  SharePointTempAuthUrlDeprecation = 'SharePointTempAuthUrlDeprecation',
  SharePointTempAuthUrlDeprecationOverride = 'SharePointTempAuthUrlDeprecationOverride',
  SharePointVideoLinkPreviews = 'SharePointVideoLinkPreviews',
  ShowUserCoverImage = 'ShowUserCoverImage',
  SmallFileUpload = 'SmallFileUpload',
  SplitDataAndPresentationComponents = 'SplitDataAndPresentationComponents',
  StorageAccessAPI = 'StorageAccessAPI',
  Stories = 'Stories',
  StoriesPostOnBehalfOfEnabled = 'StoriesPostOnBehalfOfEnabled',
  StoriesV2Cards = 'StoriesV2Cards',
  StorylineAnnouncementAudienceChannelsConfigEnabled = 'StorylineAnnouncementAudienceChannelsConfigEnabled',
  StorylineAnnouncementNotificationUrgency = 'StorylineAnnouncementNotificationUrgency',
  StorylineAnnouncementTeachingBubbleAndDisableInfobar = 'StorylineAnnouncementTeachingBubbleAndDisableInfobar',
  StorylineAnnouncementTeamsEmailChannelsEnabled = 'StorylineAnnouncementTeamsEmailChannelsEnabled',
  StorylineAsDefaultOnHomePublisher = 'StorylineAsDefaultOnHomePublisher',
  StorylineBootstrapNetworkCall = 'StorylineBootstrapNetworkCall',
  StorylineDefaultHomeFeedPublisherLongv2 = 'StorylineDefaultHomeFeedPublisherLongv2',
  StorylineDefaultHomeFeedPublisherShortv2 = 'StorylineDefaultHomeFeedPublisherShortv2',
  StorylineDirectAndDigestRebrand = 'StorylineDirectAndDigestRebrand',
  StorylineFeatureConversation = 'StorylineFeatureConversation',
  StorylineFollowBack = 'StorylineFollowBack',
  StorylineFREVivaEngage = 'StorylineFREVivaEngage',
  StorylineMediaPost = 'StorylineMediaPost',
  StorylineMediaPostCardLayoutV2 = 'StorylineMediaPostCardLayoutV2',
  StorylineMediaPostCreation = 'StorylineMediaPostCreation',
  StorylinePerUserControl = 'StorylinePerUserControl',
  StorylinePublisherCoachingTips = 'StorylinePublisherCoachingTips',
  StorylinePublisherSettingsNetworkCall = 'StorylinePublisherSettingsNetworkCall',
  StorylinePublisherTipsLongV3 = 'StorylinePublisherTipsLongV3',
  StorylinePublisherTipsShortV3 = 'StorylinePublisherTipsShortV3',
  StorylinePublisherWithCopilot = 'StorylinePublisherWithCopilot',
  StorylineThreadCoachingTips = 'StorylineThreadCoachingTips',
  StorylineThreadTipsLongV3 = 'StorylineThreadTipsLongV3',
  StorylineThreadTipsShortV3 = 'StorylineThreadTipsShortV3',
  StorylineTrendingFollowButton = 'StorylineTrendingFollowButton',
  StreamLiveEventDeprecationExtension = 'StreamLiveEventDeprecationExtension',
  SuggestedThemes = 'SuggestedThemes',
  SysInitEngageFeedback = 'SysInitEngageFeedback',
  TaggedAnswerQuestions = 'TaggedAnswerQuestions',
  TeamsBackButton = 'TeamsBackButton',
  TeamsBrandedExperiencesVisuals = 'TeamsBrandedExperiencesVisuals',
  TeamsBrandedExperiencesThreadStarterPublisher = 'TeamsBrandedExperiencesThreadStarterPublisher',
  TeamsDisableVideoAttachment = 'TeamsDisableVideoAttachment',
  TeamsDisableVideoLinkAttachment = 'TeamsDisableVideoLinkAttachment',
  TeamsMeetingAccess = 'TeamsMeetingAccess',
  TeamsMeetingArchiveFeature = 'TeamsMeetingArchiveFeature',
  TeamsMeetingMaskIdentitiesBanner = 'TeamsMeetingMaskIdentitiesBanner',
  TeamsQnAFeedReset = 'TeamsQnAFeedReset',
  TeamsQnAMessageReactions = 'TeamsQnAMessageReactions',
  TeamsQnAMyQuestions = 'TeamsQnAMyQuestions',
  TeamsQnANestedAuthAppSupport = 'TeamsQnANestedAuthAppSupport',
  TeamsQnANotificationsDeepLinking = 'TeamsQnANotificationsDeepLinking',
  TeamsQnAThreadUpvote = 'TeamsQnAThreadUpvote',
  TeamsQnAVivaEngageAmaIntegration = 'TeamsQnAVivaEngageAmaIntegration',
  TeamsQnAVivaEngageAmaRedesign = 'TeamsQnAVivaEngageAmaRedesign',
  TeamsSearch = 'TeamsSearch',
  TeamsTownhallEventInVivaEngage = 'TeamsTownhallEventInVivaEngage',
  ThirdPartyCookieDeprecationMitigation = 'ThirdPartyCookieDeprecationMitigation',
  ThirdPartyCookieFix = 'ThirdPartyCookieFix',
  ThreadCopyLinkV2 = 'ThreadCopyLinkV2',
  TopicNotificationPicker = 'TopicNotificationPicker',
  TopicsSubscription = 'TopicsSubscription',
  TopicSummaryCardIndicators = 'TopicSummaryCardIndicators',
  TranslateContentState = 'TranslateContentState',
  UnifiedTopicsFeed = 'UnifiedTopicsFeed',
  UserGroupsFromGrouper = 'UserGroupsFromGrouper',
  UserInitEngageFeedback = 'UserInitEngageFeedback',
  UserInsights = 'UserInsights',
  UserTags = 'UserTags',
  UniversalCreateButton = 'UniversalCreateButton',
  VerifiedAnswers = 'VerifiedAnswers',
  VfamSettingsMigration = 'VfamSettingsMigration',
  VivaAppBar = 'VivaAppBar',
  VivaEngageAdminBanner = 'VivaEngageAdminBanner',
  VivaEngageAmaBestAnswerRedesign = 'VivaEngageAmaBestAnswerRedesign',
  VivaEngageAmaCalendarInvitationToggle = 'VivaEngageAmaCalendarInvitationToggle',
  VivaEngageAmaMyQuestions = 'VivaEngageAmaMyQuestions',
  VivaEngageAmaRebrand = 'VivaEngageAmaRebrand',
  VivaEngageAMAOrganizerChecklist = 'VivaEngageAMAOrganizerChecklist',
  VivaEngagePremiumEventCreation = 'VivaEngagePremiumEventCreation',
  VivaEngageCollapsiblePanelRecommendations = 'VivaEngageCollapsiblePanelRecommendations',
  VivaEngageCopilotBE = 'VivaEngageCopilotBE',
  VivaEngageCopilotMVP = 'VivaEngageCopilotMVP',
  VivaEngageCopilotVNext = 'VivaEngageCopilotVNext',
  VivaEngageCopilotWAGpt4 = 'VivaEngageCopilotWAGpt4',
  VivaEngageCopilotWAPersonalized = 'VivaEngageCopilotWAPersonalized',
  VivaEngageCoverImage = 'VivaEngageCoverImage',
  VivaEngageDeepLinkFromOWA = 'VivaEngageDeepLinkFromOWA',
  VivaEngageLC = 'VivaEngageLC',
  VivaEngageOfficeAICopilot = 'VivaEngageOfficeAICopilot',
  VivaEngagePremium = 'VivaEngagePremium',
  VivaEngageQnAFastFollow = 'VivaEngageQnAFastFollow',
  VivaEngageRebrandingAdminBanner = 'VivaEngageRebrandingAdminBanner',
  VivaEngageRebrandingBanner = 'VivaEngageRebrandingBanner',
  VivaEngageTeamsLiveEventMobile = 'VivaEngageTeamsLiveEventMobile',
  VivaGoals = 'VivaGoals',
  VivaGoalsConfig = 'VivaGoalsConfig',
  VivaGoalsOverride = 'VivaGoalsOverride',
  VivaInsightsAudienceThemeCard = 'VivaInsightsAudienceThemeCard',
  VivaInsightsNetworkRetentionCard = 'VivaInsightsNetworkRetentionCard',
  VivaLeadershipChronoFeed = 'VivaLeadershipChronoFeed',
  VivaLeadershipCuratedFeed = 'VivaLeadershipCuratedFeed',
  VivaTopicsFRE = 'VivaTopicsFRE',
  WebRecorderMediaAttachmentInPublisher = 'WebRecorderMediaAttachmentInPublisher',

  // Existing experiments that incorrectly have 'Enabled' as part of their name.
  // Do not do this - 'enabled' should be the state of an experiment, not part of the name.
  // The name should instead focus on describing the feature/functionality affected.
  // Since these are already running and in use, we can't rename them, so just have
  // to let them run their course.
  CortexTopicCardsEnabled = 'CortexTopicCardsEnabled',
  LiveEventSortingChangeEnabled = 'LiveEventSortingChangeEnabled',
  ModulatorGroupSuggestionsEnabled = 'ModulatorGroupSuggestionsEnabled',

  // Experiments used for testing the experiment infrastructure - grouping
  // these separately from the regular feature experiments above. Regular
  // experiments should not have the name 'experiment' in them.
  ClientForwardExperimentForTesting1 = 'ClientForwardExperimentForTesting1',
  ClientForwardExperimentForTesting2 = 'ClientForwardExperimentForTesting2',
  CrossPlatformExperimentForTesting1 = 'CrossPlatformExperimentForTesting1',
  CrossPlatformExperimentForTesting2 = 'CrossPlatformExperimentForTesting2',
  ExperimentForTesting1 = 'ExperimentForTesting1',
  ExperimentForTesting2 = 'ExperimentForTesting2',
}

export type ExperimentTreatmentValue = string | boolean | number;

export interface ExperimentConfig {
  readonly id: string | undefined;
  readonly projectTeam: EcsProjectTeamName;
  readonly treatments: ExperimentTreatmentValue[];
  readonly defaultTreatment: ExperimentTreatmentValue;
}

export const experimentConfigs: ExperimentConfigs = {
  AdminMuteUser: {
    id: '58c15c56-4f98-496f-baad-210c30c76973',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AdminTenantSettingsRelayOverhaul: {
    id: 'd003c2ed-2857-4cee-aec5-b2e2b3f7bc82',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersAdminAIFeaturesToggle: {
    id: '0a688e8a-29a2-40f5-8883-bea082057a03',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersAISuggestedCommunities: {
    id: '82c5b20f-058b-4953-a99e-f46bcdb3a0ae',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersAISuggestedTopics: {
    id: 'e0307cc4-554d-431e-9139-a465368678c0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersCommunityAISuggestedTopics: {
    id: '0cdf41c9-ce56-4c30-a3b8-e557b3a7b78f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswerCommunityClientSupportsQuestionTitle: {
    id: '1d8019df-3772-493c-b09f-51026014580a',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersCommunityEnablement: {
    id: 'f02d5ba5-ec0e-4346-981d-a5fdc9aa30d7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'create_enabled', 'edit_and_create_enabled'],
    defaultTreatment: false,
  },
  AnswersCommunityForAll: {
    id: 'd3bb5e51-5f56-4871-b769-360571f0226c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswerCommunitySearchUX: {
    id: '4435a113-a41e-4a86-9517-5877cc008ab7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersDefaultRoutingInHomeFeed: {
    id: '26a36094-039b-48d1-878c-49f7d9b9dcd2',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersDismissTopicSuggestion: {
    id: '53cce6a8-38cc-41d5-8661-007a1e6b5073',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersForager: {
    id: 'e86fc706-4e92-4fa3-8376-199716e811ee',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersGrowthPublisherQuestionPrompt: {
    id: '14c1696b-f0ee-41a9-a448-930d1a3ff5fa',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersInlineExpansion: {
    id: '35421ec3-e148-43ce-a395-809d70b95697',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersInEngageTopics: {
    id: '8c523cf8-d233-4492-b09d-2bc3b7d79b5b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersInVivaGA: {
    id: '380a21a6-bc1e-4619-aa37-f11e947f9844',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersOnboarding: {
    id: '61d43214-e71d-44e1-b2a9-285a3c1ac7f0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersOnlyMode: {
    id: 'adfa8eca-2626-43df-9693-da8f9ba34bd7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersPostGAExperience: {
    id: 'b2b9090e-7752-4050-bf20-831f2c940ea9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersMoreForYouQuestions: {
    id: 'c7566452-244f-49bb-a23c-0ad3727fc1f1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersNewPill: {
    id: '7a169e37-a990-4e1d-bb1c-9719fca0834a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersPublisherWithCopilot: {
    id: '0e50fb76-800a-4dc4-adda-202ea527d972',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AnswersTopicManagementPainPoints: {
    id: '48bab08d-6dd1-4d0d-ad2a-5fbe1907caea',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersTopicPickerAlignment: {
    id: 'f9d44728-a090-4628-ad56-dba52c558975',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  AnswersUpdates: {
    id: '4f9555aa-a589-487f-8b8b-a8a43fa3b9ab',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleCreationFlow: {
    id: '70efb65b-f06e-4272-ab52-d2b0f3822b44',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleOpenSameWindow: {
    id: '21fcb795-ea10-4bbe-acd9-85bf9df90dd8',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleWithLeftNav: {
    id: 'c1e5d1f6-3df5-4a36-8529-5c9b501840e2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticlePublisherWithCopilot: {
    id: '0e50fb76-800a-4dc4-adda-202ea527d972',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ArticleViewMenu: {
    id: 'ca425cf6-2548-4e9b-82b9-c3721442b882',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AtMentionCustomName: {
    id: '0f7581eb-ad8e-4acc-80fa-75214dd00bed',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  AutoSuggestionCampaignHashtag: {
    id: 'acc4854f-ed9d-4082-8f56-5f2bba1d2bed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutAlpha: {
    id: '72b2edd7-fd66-4600-a011-86620b31f326',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutBeta: {
    id: 'b04de4f5-3243-4ada-83d2-b959f33c7323',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutCanary: {
    id: '97d4aa63-c7cb-4fa1-9e5b-0ad05f882d74',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutDogfood: {
    id: 'c4970364-0977-4f25-98fc-363b12db5aea',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd25: {
    id: 'e7982880-04ae-432a-99b8-373bea07f6a1',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd50: {
    id: 'f6ef418e-6d13-4403-aed1-bedd19875a95',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphQLApiVNextRolloutProd100: {
    id: '8b86d14a-6f85-4598-b877-9c433560afcb',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendGraphqlApiVnextEndpoint: {
    id: 'fd389c01-9fdd-440d-af71-41aab31f2a57',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9],
    defaultTreatment: 2,
  },
  BackendLiveEventFeedCaching: {
    id: '298a9ad9-4a09-4bc9-b03c-57409c423b7e',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendLiveEventFeedCachingByTenant: {
    id: 'cf0d025e-c359-4988-8ab4-abed3a5f7e77',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackendOcularCosmos: {
    id: '6efb151f-2e3b-466f-9fac-d14928e0d815',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BackendStreamieCosmos: {
    id: '13753d6c-0a9e-4927-bf80-524e4fb99bba',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BellPageSize: {
    id: '5d034307-8927-41cc-bdc1-2b9b000bc466',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BenchmarkingInsights: {
    id: '4f376e4c-cb67-413b-9c42-8418a0f3aec1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BespokeCommunityCreateEdit: {
    id: '63d38f2f-36df-4d03-b8ed-fa4f7e07b48f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BookmarkThread: {
    id: '73b842f4-791f-4157-a5b2-76917957057f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  BulkRemoveTopicsInEngageAndAnswers: {
    id: '464a919e-e59f-4ca1-973f-aace076ea19c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CampaignHoverCard: {
    id: '8302d48b-9695-4ebc-b5f6-ce2627cd0995',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsHub: {
    id: 'aefbd4b4-7240-4368-a057-35889afef9d3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsCoOrganizers: {
    id: 'c10ce8d9-b5ee-49cb-b815-544393f57c5e',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignsExecutiveSponsorship: {
    id: '671d7ef6-08c8-4643-84c6-be6fe85d3df3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignExecutiveSponsorRefinement: {
    id: 'e346f173-4cc4-4dc4-b786-ea71c72f0c90',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignFollowerDetails: {
    id: '0b6a86fb-6f38-45fc-b33c-c148670f7e92',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignPublisherWithCopilot: {
    id: 'd218be62-eb7a-4acc-b677-3739c8086033',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSashAvatar: {
    id: '16cd896a-947c-4767-ad07-d12496b328ad',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSearch: {
    id: '07da9e7a-4510-408e-a5a4-00f7ce4e0ab5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignSearchImprovements: {
    id: '58301587-7b96-443e-b3c4-72ef1a668693',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignPrivateMessage: {
    id: '908d243c-add7-4cae-b2f2-dae99cc15de3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CardPresentationOnSearchTabs: {
    id: 'ce2a07c5-dbb7-400b-a7a8-9122cbf0e2ab',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CoachingAtMentionInAnswers: {
    id: '7942f8d0-b21d-48cb-8a70-eb9459ee895d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CoachingInsights: {
    id: '56b25c73-de08-4159-b0cd-d507f53853d1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityAma: {
    id: '7a722cf9-e0e6-4acd-867f-e6557b4a7568',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityBadgeAdmin: {
    id: 'ace0c8c8-713f-433d-9807-2617506e7cbb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCampaigns: {
    id: '4f8ed957-4e32-4dcd-be65-39c5361403e6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityCoachTips: {
    id: '45107b86-6a6f-4842-bd70-e3b9469361e6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityExperts: {
    id: 'c544340c-0b40-4f2e-9659-25e58bdd04ed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CommunityFeatureConversation: {
    id: '40ad4c65-5ac7-4f59-bf4f-7b4fde1f1883',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsV2: {
    id: '7eb95022-fcba-49c0-b734-9e476b9e7eba',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsV2Optimization: {
    id: 'fad3b594-d9bb-445a-9d02-83d893e2de1e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityInsightsV2ThreadMetrics: {
    id: '1f6924f8-eebd-44f3-9bde-8d3e92b1dd95',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeads: {
    id: '25f7fc54-ecbd-495e-9014-3bae205e8f91',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityLeadsAndAutoPin: {
    id: 'beae692c-0343-4008-8003-64d56a4b8f19',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityManagerSubscriptionTip: {
    id: '44568163-115a-4170-b9c8-0314dab7745d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityMultiPinThreads: {
    id: 'acf83872-e4e4-4d0b-a382-ec73b02ffc50',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityPublisherWithCopilot: {
    id: 'f5a34d98-8093-4cb1-ba41-0c5cc2139e7c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityQuestionThreadUpdate: {
    id: '5618bb4b-b608-4e04-8e91-e8e0eb9a8579',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySettingsPage: {
    id: 'b050044d-86ef-45c6-985e-d8af5184405c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySetupTeachingBubbles: {
    id: '9665f8af-afb7-4f17-83d6-dcaa4e7ea275',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunitySubscriptionBubbleOnly: {
    id: '62b198ee-a1ea-4235-af37-36e43c16942c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CommunityTopQuestions: {
    id: '2556a0dd-f9d5-484b-b7d5-a478a9f562f0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  CompactHeaderCommunities: {
    id: '3f50f54d-fbcd-4388-9828-ef071a51da6f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompactHeaderGeneral: {
    id: '3a8152dc-3f83-4334-ad84-be9acbbdb504',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompactHeaderStoryline: {
    id: 'affd7fb3-e3d6-4e99-968e-786e19ff8295',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopyReactions: {
    id: '4626b924-7ff3-48ab-82e1-50e17210ae63',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargeting: {
    id: 'f86439d9-fddb-4af1-a506-a7984476c5c6',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignTargetingV2: {
    id: '4d59a1d3-1448-4c84-9816-7653768ab854',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignAnalyticsWithSearch: {
    id: '59446f36-f0d7-4de8-b3d6-a62bdcbb4990',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CampaignEngageDigest: {
    id: 'a2a7200d-c2fc-4921-8c62-f30be781d08f',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CompanyLogoInLCHeader: {
    id: 'ca32a32d-1b98-44ab-87fc-de35ef47838e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CortexTopicCardsEnabled: {
    id: 'ae26490b-84e4-4c54-b485-97dafc981ec2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CondensedQuestionFeed: {
    id: '5bcf59f7-1b56-4445-8af4-6c373d676591',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ConversationInsightsV2: {
    id: '7dce6f42-fd1b-4acf-9454-57a44d9273ec',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ConversationInsightsV2ThemeSummarization: {
    id: '8a930c50-189c-463b-b798-fc35202e2ba4',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CopilotCommunityConversion: {
    id: '121f2bb4-d221-457c-ad66-add8bef178eb',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CSVUploadGroupMembers: {
    id: 'c435b040-40d3-4e6d-98ec-321f6229e34d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ClientForwardExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  ClientForwardExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  CrossPlatformExperimentForTesting1: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'c1'],
    defaultTreatment: 'control',
  },
  CrossPlatformExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DeprecatePostCommunityEmail: {
    id: 'ed529a5d-c2a2-4940-9e39-c53f89490692',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DisablePollPostType: {
    id: '57738844-f4ad-4e10-bc25-8b1736ceae70',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverCommunitiesV2: {
    id: '39b449a2-1fd5-4599-89d0-e2a86a1a16a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['disabled', 'enabled'],
    defaultTreatment: 'disabled',
  },
  DiscoverOfficialCommunities: {
    id: 'b1de80d6-8d37-4ac3-980e-22264edb9654',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DiscoverTopicPageImprovements: {
    id: '7c553352-7eb1-4c54-8fef-ddac6b139e98',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  DivisionalBespokeCommunity: {
    id: '6f9c3ced-854b-4bc2-9af3-7db4be804007',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DomainMigration: {
    id: 'af478543-716d-4c0f-8233-eb60a9a38e20',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftSorting: {
    id: '98e0ca69-7b24-4ce1-a33b-705b2fd15cbd',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  DraftPublisherWithCopilot: {
    id: 'f8124b33-1668-4c7b-937a-143c9b9d88d4',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedMsal: {
    id: '012d222c-422f-446b-8477-c5dcad4cc15a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EmbedSupportForNetworkContext: {
    id: 'cd378d7c-89b3-4b1c-9f8c-654569e2eff5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnhancedDigestDiscoveryDesign: {
    id: '281e84a8-537f-4440-93e2-9b7c91289a99',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'all_surfaces', 'list_view', 'reading_pane'],
    defaultTreatment: 'control',
  },
  ExpandedReactionsEnabled: {
    id: '7196531b-8e19-464d-a04b-ee2e0ea08e2b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: true,
  },
  ExperimentForTesting1: {
    id: 'fake-guid-for-testing',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 't1'],
    defaultTreatment: 'control',
  },
  ExperimentForTesting2: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ExternalNetworksInGlammer: {
    id: 'e3aa14aa-bbb6-4ce8-8b91-3bff150f6c85',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  FAQIfy: {
    id: '841a0b15-388f-4059-9b18-4065835cff5d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FAQIfyAnswersCommunity: {
    id: 'f339f29f-1933-442e-b9cd-9a887d7534da',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FavoritesDragDropReorder: {
    id: '83593909-57d5-49e8-b3f4-eca2e2c142d2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  Fluent9Toolbar: {
    id: 'bee6adf5-c92c-453e-9afe-36a2ce794f8e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TopicNotificationPicker: {
    id: '87ed2187-690a-4e6d-9466-39448ae9e7ce',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TopicSummaryCardIndicators: {
    id: 'aa670116-5858-42fc-b3c6-dbb949ea7fa0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TopicsSubscription: {
    id: 'b69cd0c3-a89e-4eb2-a48d-7c46302829c7',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  FollowButtonHomeFeedThreadWithGreyColor: {
    id: '440bb634-1b43-44c8-9251-e9d02a469570',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  GroupFeedFilterAndSortByExp: {
    id: 'cff752e6-7035-4cd5-9264-d6340d64b3d9',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['new_recent_posts', 'all_recent_posts', 'default'],
    defaultTreatment: 'default',
  },
  GroupsFromGrouper: {
    id: '49b25bb2-375e-46ce-8624-6224d5254df0',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HomeFollowingFeed: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  InFeedUserSuggestions: {
    id: 'edc8645c-a10d-4ab1-aab3-34842a682c5d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'rankie', 'enabled'],
    defaultTreatment: 'control',
  },
  InformationBarriersPhase0: {
    id: '43ad10c3-30df-40d6-8cb2-7a9bc0c1ea0c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  GroupHoverCardV2: {
    id: 'e22b6ca1-ad23-4176-afbf-ab7b9365648e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  HydrateAnswersTopicsAsync: {
    id: 'c12475ea-b7f2-41d3-acc8-959d517f2ffb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  KnowledgeBespokeCommunity: {
    id: '992716ec-e54a-48cd-9885-996aaacc3cd3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  KnowledgeCommunitiesUnansweredFeed: {
    id: 'ed71040f-6d61-404e-9379-b6229d2d3483',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderAudienceFeed: {
    id: '45242ffb-565d-45c3-9aec-cead8078233c',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LeaderDashboard: {
    id: 'a359d84d-2676-4683-b255-48660a52ab10',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadershipCornerPinnedPosts: {
    id: 'ea5334fb-dfb9-4eb0-a15e-f2569df04eba',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderGroupsAddAsync: {
    id: 'c67be930-601d-40f2-a300-b3027ea21b10',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderIdentificationFRE: {
    id: '7fbec9fc-302d-4800-876e-77a6df7ac5d2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderIDSmartEntryPoints: {
    id: 'ba201a97-746e-4d4c-8038-51d472e20e19',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeadersAudienceM365Support: {
    id: 'bc62da45-9b8f-493a-940f-fc99ef2bddbb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderManagementActivityLog: {
    id: 'a4c3c54b-2bbf-4890-9129-1a45d59a3297',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LeaderOptionWebpart: {
    id: '1209c849-4fab-4a02-b0fc-1744d592d649',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LightboxFollowUsers: {
    id: 'd34c34e0-815c-4133-a17d-fe181895cf4d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LimitConversationMoveSettingsAndFilter: {
    id: 'd9aa165e-da2d-4f08-a641-94bad06aa4e5',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LiveEventSortingChangeEnabled: {
    id: '33d94caa-e259-4c4f-be93-656012fe9b84',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LogProtobufEvents: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  LongFormContentArticlePublisher: {
    id: '202f8671-9322-4bef-9922-b1ab63deca87',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  LongFormContentArticleView: {
    id: 'f247289d-02e7-4931-9e1b-af215bf3f798',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RestrictPostingAnyGroupRollout: {
    id: 'de3b6c60-f521-4e7d-b89a-2c8d19d81785',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoption: {
    id: '344b3d2d-7100-41e9-a7b2-5a7c7d493a6f',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionContentStarters: {
    id: '9424756a-8c02-48d3-9838-fab91a6db439',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionSuggestedMembers: {
    id: '94573c25-cadd-485f-868f-d5e91d8ec8a4',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  M365CopilotAdoptionTopQuestions: {
    id: '7bd82aab-270b-4045-b8e2-45da2e06ec60',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MediaPostStorylinePostMSIT: {
    id: '9ca54bd7-ce52-490e-976f-5feef3a8e6a3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MicrosoftDesignerApp: {
    id: '49497680-16e2-43f4-bc69-0363063618c2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ModulatorGroupSuggestionsEnabled: {
    id: 'bfd3fd32-6e3c-41c0-a792-8962dab5d283',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MoveTopicSettings: {
    id: 'f3486a3a-aa9c-4cc0-b1e3-ffe67262791b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOAdminToggle: {
    id: 'a466846a-de55-4370-ada6-6f172ac23126',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOLeader: {
    id: 'df92b4cc-fa07-4198-ac7a-4106215c0c2c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOStoryline: {
    id: '773bacc9-2f0d-41f8-ae8d-d8528c0ef1bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBadge: {
    id: '1709ba31-c004-438a-bc2d-98172009fe26',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOBlendedInbox: {
    id: '50746bf4-b609-43de-9287-c67c52b25d7d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCampaigns: {
    id: 'ecb84501-2887-4ffe-8b66-bf00c1eca68d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOCommunity: {
    id: 'e34e6b47-9c6f-4ce9-87c5-f171f05b1e9c',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOConversationsSearch: {
    id: '63966a3c-0c6d-4db4-83a5-5aa1e9e83245',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOGraphVNextResolvers: {
    id: 'ddee0f75-88c7-4f47-93bd-d9d305dc8fd8',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOOpenResourceUrl: {
    id: '7ff8ed08-b404-4f8d-929a-902f43e50edb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOPolicyEngageAdminPortalPage: {
    id: '8d19e764-4203-47aa-945b-d3c1b656593f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MTOTeamsMeeting: {
    id: 'c4cd6513-4858-4461-ac54-ed2dbc9085bf',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  EnablePermalinkDeeplink: {
    id: '76203ecf-f92b-43ef-8a76-5aad974ac86b',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MultiTenantOrganization: {
    id: 'eaef51f5-5324-4fff-a9be-189da3de3a89',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  MobileCrossSellThreadViewV2: {
    id: '38b66b3c-4070-49d7-8503-67c0b615bb0f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'qrCode', 'banner', 'coachingTip'],
    defaultTreatment: 'control',
  },
  MyGroupsAdminOfFilter: {
    id: 'b1be92fd-10e9-404b-9ea0-9c987e54a8eb',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NestedBestReply: {
    id: 'ed32c679-bc95-4b36-a917-012c9a4e132b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  NetworkQuestionsInConversations: {
    id: 'b844c74d-8d80-41f4-968d-ca676ec73a76',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OauthTokenExpires: {
    id: '79a74dca-0f30-49c3-a507-9d3a08e91102',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OneCameraV3: {
    id: 'b4c0de9d-144f-4dd5-9357-f6453c73d48b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnePlayerNative: {
    id: 'c014fb1e-2d91-47e7-9d63-005fa8fd0490',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAEngageDigestLeaderAnalytics: {
    id: 'd3531dcf-1a87-4eed-bbc3-721ac3526e7f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWALoadTopicsSeparatelyFromThreadList: {
    id: 'c0f7a078-1c51-4c42-bbdb-d4e39f369d6e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OWAMoreForYouReduction: {
    id: '5de6aa59-a415-487f-810b-2ac29f0441ca',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OdspFilePickerType: {
    id: 'a316df71-760f-47ec-97fd-84e11f14017c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'group', 'onedrive'],
    defaultTreatment: 'control',
  },
  OfficeTopics: {
    id: '859373f9-fd86-46e8-a452-6ee50d68c6b6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  OnboardingBannerInAnswersDigestEmail: {
    id: 'a911b014-18a3-4dcb-96cd-1244e6273cab',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  OpenPublisherWithCopilotModal: {
    id: 'd3ce66e7-7c33-4f42-a167-9b275a20cd15',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'home', 'group_storyline_campaign', 'home_group_storyline_campaign'],
    defaultTreatment: 'control',
  },
  OutlookAnswersDigestBanner: {
    id: '43e9e2b7-a180-41a6-a9b7-2fbeb2b822be',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PageThreadHomeFeed: {
    id: '297975e3-1a9f-4f4b-9248-019eaf25fac1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PeopleSuggestion3SV3: {
    id: '5d873e2e-b60c-43d5-801a-716cce0894bc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, 'enabled'],
    defaultTreatment: false,
  },
  PinnedFiles: {
    id: 'b2b7ae31-803f-42f8-833b-5d99489cc3a5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PolicyReminderRedesignRRv2: {
    id: 'f382975e-8e85-4ddf-b373-2a0cea0e8724',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'bottom', 'top'],
    defaultTreatment: 'control',
  },
  PollsSchedule: {
    id: '91f8c0a8-b9e3-4028-96e7-eb9facd7f02c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PostOnBehalfOfCommunityHomePublisher: {
    id: '2d1a61c7-1957-42ab-94b6-faa67b639669',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PostQuestionUpsellBetweenSearchResults: {
    id: '7ae80787-5756-4d1d-9988-9a3934da57f7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrefilledDefaultAudience: {
    id: 'a7c7ce2f-c586-40c7-abae-8d2c916a3572',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PreloadFeedAfterUserData: {
    id: 'd23567c1-3f29-4cb1-a0ae-2c83f4d1b6b6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PrivateReplies: {
    id: '4696293a-9b33-426a-8984-cc326bc9b5df',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PrivateRepliesEditThreadStarter: {
    id: '3f29f70e-6d6c-49b8-8ca5-eb9d760e40b1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherAbandonmentOCVSurvey: {
    id: '96eea534-dc14-4e29-a10b-cd4c3ace6545',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherQuestionCoachingTip: {
    id: '100ca10f-05c8-49d0-897b-0460db3e2888',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherSuggestedTopics: {
    id: 'df2bddf4-61dd-4bc5-a1c7-778939fe36ae',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionsQueue: {
    id: '2c93f569-5660-4f0d-8f86-d308cba0cf9f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PublisherEmojiPicker: {
    id: '3b3c8368-b68a-46fc-b8c6-ce46e3393568',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionTitles: {
    id: '4e5b9a92-cd36-4477-95bd-d4118d8ff432',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuestionTitlesV2: {
    id: 'a981220d-4f03-4a3b-97e0-05dd9a1a9250',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  QuickNavManageMyThings: {
    id: '6a005258-30ee-443e-9b6e-ff1024e2b8c0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  PWALegacyBrokenExperience: {
    id: 'ede9763e-cfe8-4d4b-806f-21dd96be8409',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  PWALegacyDeprecation: {
    id: '7d658113-c6ca-49b7-aa5b-dc53c76e3a14',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ReactionSimplification: {
    id: '7119895f-2b5b-4e09-93a4-a745c0c96c48',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ReadOnlyMode: {
    id: 'da33e692-30d5-4ade-b69f-f0b062b143e5',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RecommendationBarCampaignFollowBtn: {
    id: 'c4883b79-4b7b-404e-8fa1-a1cae2c80621',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemovePublishButtonInDismissedFeed: {
    id: '44338a3e-dfe9-4310-8672-4685774e8d04',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RemoveTopicsSDKForVivaTopicsInFeeds: {
    id: '79c3a1d3-525a-46ff-8090-4021bd8f5709',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  RemoveTopicsSDKDependencyForVivaTopicsInFeeds: {
    id: '4992995f-b0d5-4b77-997c-703e977eda4d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  RestrictedUser: {
    id: '1bafa77b-67ff-408b-8e35-7ce00fc3a561',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  RoleBasedFRE: {
    id: '6a88d980-c993-4549-8559-d07a184527a7',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  SearchAutoGroupScopeDisabled: {
    id: '1481610f-9094-41dd-bea6-b11429cda0a4',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchDiscoverabilityFRE: {
    id: '179aa02b-969b-4288-b812-d2998c9b74e1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'treatmenta', 'treatmentb'],
    defaultTreatment: 'control',
  },
  SearchPeopleInConversationFilter: {
    id: '5254e378-d967-45fe-875b-daa41b5fc746',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchThreadStarterSenderFilter: {
    id: 'df386d04-7489-4ea5-ac3d-3d1432d7ac3e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SearchPostTypeFilter: {
    id: 'd3042ea9-63ed-4f5c-89c4-f4423eb16174',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ServerSharePointWebLinks: {
    id: 'cb6da583-69f6-422d-ba1c-0d1bf9af85e8',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  ShareAMAPoboToStoryline: {
    id: '6649bf4b-142b-4061-a46c-a1b2103d6551',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointVideoLinkPreviews: {
    id: '28323fd7-5caa-420d-998d-88f9224d9698',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecation: {
    id: 'e74e2593-fcd8-4b5c-999f-27f355a8aa17',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SharePointTempAuthUrlDeprecationOverride: {
    id: 'ca32cba4-f69c-4a60-8224-a1746638f285',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ShowUserCoverImage: {
    id: '1b55e8eb-36f3-4022-ac2c-2588d3869931',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SmallFileUpload: {
    id: '8c7e99ba-f485-46ea-9c15-963168beaf73',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SplitDataAndPresentationComponents: {
    id: '7bab3ae5-1adc-46f4-ba94-d301aa631953',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorageAccessAPI: {
    id: 'ea1af28b-8532-4ef9-a175-cfef99424bdf',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  Stories: {
    id: '06ca9171-c49a-4437-87ff-db71db80eca0',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesPostOnBehalfOfEnabled: {
    id: '466fb696-01ba-46f9-b815-5841afd683d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StoriesV2Cards: {
    id: '8ce624f9-6d36-46be-a1b8-66a4e9200e0c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementAudienceChannelsConfigEnabled: {
    id: '815edf06-def6-4e9e-93f5-dee926e9c4ad',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementNotificationUrgency: {
    id: '4915afb3-27fd-4dac-8a02-dd6cc20310c7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineAnnouncementTeachingBubbleAndDisableInfobar: {
    id: '8714e391-0b32-4202-9c11-5da24443b1c5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAnnouncementTeamsEmailChannelsEnabled: {
    id: 'bda9c5a1-3e58-40ce-8525-04605ef7fb28',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineAsDefaultOnHomePublisher: {
    id: '607d8f62-67cc-46dd-8ab9-05dfe7093edf',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineBootstrapNetworkCall: {
    id: '6e42a50a-6e69-4530-95db-d031602db681',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherShortv2: {
    id: 'ffde70ab-2ccf-4025-9cb2-6b386c65f7a1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDefaultHomeFeedPublisherLongv2: {
    id: 'cd8b5099-2742-4e28-bf15-e2170c394bd5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineDirectAndDigestRebrand: {
    id: 'a9c87cbf-fbab-45b9-b081-0d60f239ce37',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineFeatureConversation: {
    id: 'd7bd2914-15a3-4557-a105-46f340f6ee97',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFollowBack: {
    id: 'e134b15f-4875-4f81-b180-a2777912074d',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineFREVivaEngage: {
    id: 'af384543-6d30-4364-86ed-a119538de985',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylineMediaPost: {
    id: '289e4542-d271-4c2d-82bd-58aa4c43cbf0',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineMediaPostCardLayoutV2: {
    id: 'c3106932-78d7-477f-9abc-7f0bfff395ef',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineMediaPostCreation: {
    id: '5128bdd7-2bc2-42ac-9b88-061a8697f7d8',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePerUserControl: {
    id: '974480fc-4e4d-472a-8785-aead29cab958',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherSettingsNetworkCall: {
    id: '968afe62-d291-42c8-8816-9b5d99d86cfa',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  StorylinePublisherCoachingTips: {
    id: '31c06d83-f8eb-4423-a704-9294705c5ab5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsLongV3: {
    id: '6ccecbf9-797e-4289-b9ef-1976e6e78cd3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherTipsShortV3: {
    id: 'aaaa837e-517c-491e-b691-512b2b14d6b3',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylinePublisherWithCopilot: {
    id: '4817f002-7821-4a08-8d2e-ad6b860b03de',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadCoachingTips: {
    id: 'd02b84c7-32c3-42f4-8edc-a9116e7054cc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsLongV3: {
    id: '6980c260-9492-4754-a800-c0caf6bada91',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineThreadTipsShortV3: {
    id: '151b08a8-8224-4a4b-803a-d768bdfa2d72',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StorylineTrendingFollowButton: {
    id: 'f56abf39-e462-46ce-ad76-ddd572a1e20c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  StreamLiveEventDeprecationExtension: {
    id: '327f469b-604b-496a-9935-76ae9d9971e1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SuggestedThemes: {
    id: 'b6b15be7-6747-40e9-85ca-98b400a3900c',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  SysInitEngageFeedback: {
    id: '10c01992-d86d-429c-bcf2-114bcde6fce9',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TaggedAnswerQuestions: {
    id: 'e6dd2e0d-7962-46f6-ba0a-b28023cf0d8a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBackButton: {
    id: '78187586-38f7-4984-b4e4-b8b9ea9a06d5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsBrandedExperiencesVisuals: {
    id: undefined,
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['off', 'on', 'teams_storyline_only'],
    defaultTreatment: 'teams_storyline_only',
  },
  TeamsBrandedExperiencesThreadStarterPublisher: {
    id: 'd1187f75-2668-4721-9a95-11aaa0b7db42',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['off', 'on', 'teams_storyline_only'],
    defaultTreatment: 'off',
  },
  TeamsDisableVideoAttachment: {
    id: '9ffa3306-ccbe-48d3-8e5b-4b07bb7bd315',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsDisableVideoLinkAttachment: {
    id: 'ab6de391-37cd-4087-a251-64979927b000',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingAccess: {
    id: 'a1e4ad9b-3252-476f-8d36-d1ab593eea1e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingArchiveFeature: {
    id: 'dbc04bfd-d532-4733-9f28-b8989a797031',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsMeetingMaskIdentitiesBanner: {
    id: '4e3e9c95-61f3-4696-9261-2f133c295417',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAMessageReactions: {
    id: '5c5e3512-c64c-49c7-9e4c-80196146e719',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAFeedReset: {
    id: '843e64a0-d562-462b-bc22-14404b918cad',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANotificationsDeepLinking: {
    id: 'f051bee8-8271-4a36-9d5c-cfba7c37ff9f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  TeamsQnAThreadUpvote: {
    id: '579fb564-0151-42d3-9416-4f9e351770a1',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAVivaEngageAmaIntegration: {
    id: 'ecaea425-6f6c-49c4-9dbe-a68dd083cdda',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAVivaEngageAmaRedesign: {
    id: '2dd99733-c6c8-4672-b88b-0f2f87519016',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnAMyQuestions: {
    id: '1838055c-9562-41b9-8cdb-e442726a3445',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsQnANestedAuthAppSupport: {
    id: 'feb5e4bb-2d8f-4d84-9009-5c0b8101c495',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsSearch: {
    id: '9cc341e5-b28d-41e1-ae51-a372bf3798f6',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TeamsTownhallEventInVivaEngage: {
    id: 'ae8b760b-8ed5-4477-b1b0-30715384c65f',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ThirdPartyCookieDeprecationMitigation: {
    id: 'ec55f78e-e8de-4f98-9725-ea5d0821ce9b',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ThirdPartyCookieFix: {
    id: '030bb639-7605-4387-9c94-e42e5845af82',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: false,
  },
  ThreadCopyLinkV2: {
    id: 'a7d57c9e-704f-488d-8ab9-a0dfad8c42dd',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  TranslateContentState: {
    id: '80d74ee5-845f-4c40-83dc-075b3a86e18e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserGroupsFromGrouper: {
    id: 'e745b9c1-095b-45f6-a2aa-a4989bb2c0d8',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserInitEngageFeedback: {
    id: 'f4d4e1f6-4a5d-4b6c-8f6a-0b3c1b5a6b7b',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UserTags: {
    id: 'cc278c50-d599-4b2f-9a7d-33548c2cfd79',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UserInsights: {
    id: '7d5f49c9-25c0-46fd-8679-83880a68708a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  UnifiedTopicsFeed: {
    id: '14e29a6a-f792-458d-8456-062f8374c65d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  UniversalCreateButton: {
    id: '9ff07ca8-d5f4-4fa1-87be-18e937f32235',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VerifiedAnswers: {
    id: 'c694530f-466a-497e-955a-b7b5dfe547dd',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VfamSettingsMigration: {
    id: '69c50b59-3ddf-4060-a5ad-56acc0d95a26',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaAppBar: {
    id: '18e154dd-b32a-42b8-b555-ef2bfb161823',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAdminBanner: {
    id: 'f81f90cd-46c2-4caa-990b-f91f448ca776',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaBestAnswerRedesign: {
    id: '88c2eece-1e6a-46eb-9ba4-b7deed18c318',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaCalendarInvitationToggle: {
    id: '69701c3e-6979-4499-8b84-17f079056a15',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaMyQuestions: {
    id: 'c89e7fa0-540e-487c-b4af-23cb21c86cd2',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAmaRebrand: {
    id: 'ee6fc432-faa6-44ae-9d12-bf4daf22e167',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageAMAOrganizerChecklist: {
    id: '66bf8810-cb93-4480-8282-df1b3647eeac',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngagePremiumEventCreation: {
    id: '2fa7cf50-3243-4c51-98ec-2523af5cd67e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  BackButton: {
    id: 'c338cf06-3658-48a1-a9c9-264c2ba31e06',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCoverImage: {
    id: '52589660-bd2e-495b-8264-3729d18bbbb5',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageDeepLinkFromOWA: {
    id: '2809a765-1843-4189-9460-cb296610a0f7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngagePremium: {
    id: '7967125b-c339-443b-927f-c7f0a908ae30',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageQnAFastFollow: {
    id: 'cf9819bf-aa91-4d40-a5f6-f3ad28e3be41',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCollapsiblePanelRecommendations: {
    id: '2cc0b58b-35a0-47d8-aee4-51c37f7aef0b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotBE: {
    id: '8d51b16b-0cf0-414e-b3d9-5ca3bb56b443',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotMVP: {
    id: '6e02a4ce-c0e1-4c36-bcdb-9e21e57fd501',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotVNext: {
    id: '27fedd18-bcb6-4110-b324-8a6925f1689e',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageCopilotWAGpt4: {
    id: '0453b07b-59e0-4345-8514-d19e436d946f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageCopilotWAPersonalized: {
    id: '44420984-e67f-4c5b-a5c6-7b43faaef021',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageOfficeAICopilot: {
    id: '0a99b068-262e-4c63-a7a0-42a149a33ba0',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageLC: {
    id: 'f01b8142-2f47-492c-a640-b3836b8b7afc',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsNetworkRetentionCard: {
    id: 'fcdefc4e-a5b2-40d9-8e5d-c7a68043e771',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaInsightsAudienceThemeCard: {
    id: 'c2fb6d1b-27e3-4874-b037-1733e2af6173',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipChronoFeed: {
    id: '0bc20bf9-4197-40fe-b262-912c9bebf58b',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaLeadershipCuratedFeed: {
    id: '3f8817dc-c4c0-464c-a2f2-34b5d1b0fd81',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaEngageRebrandingBanner: {
    id: '9cee3a74-b547-43a7-939d-a0aa9b5a9de7',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageRebrandingAdminBanner: {
    id: 'd976eaa7-08d3-441b-9ee6-b48a05f4d6ed',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  VivaEngageTeamsLiveEventMobile: {
    id: '6f2f97ba-ec37-4508-8b12-fbbf3e648186',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoals: {
    id: '5264c978-4a61-4f32-a6eb-019c755ea0a4',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoalsConfig: {
    id: '09431989-cb2b-47d2-bc54-71b25a0652d9',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaGoalsOverride: {
    id: '16463115-cfd2-4ab6-85b6-507f554577ff',
    projectTeam: EcsProjectTeamName.CrossPlatform,
    treatments: [false, true],
    defaultTreatment: false,
  },
  VivaTopicsFRE: {
    id: '8248931d-3124-4aa8-863c-46b8a44fa60a',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: [false, true],
    defaultTreatment: false,
  },
  WebRecorderMediaAttachmentInPublisher: {
    id: 'bf6acfd3-e7b4-4283-a076-963aeb073e2d',
    projectTeam: EcsProjectTeamName.YammerClients,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  NoWFMessageBodyInGroupMessageCreationResponse: {
    id: '9c4d957c-94b1-43d8-bcc6-84a14db0cde2',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MinimalWFPayloadOnReplyPosting: {
    id: '4def6d5d-ad49-4be4-8d63-dede011d672f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
  MessagesReactionsAPI: {
    id: '32f18ade-ec9f-478d-aa5a-fa2baa4e282d',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: [false, true],
    defaultTreatment: 'false',
  },
  OptimizedReactionsFetching: {
    id: '5fc95130-6444-4e47-92fc-f3ca5a16ac6f',
    projectTeam: EcsProjectTeamName.ClientForward,
    treatments: ['control', 'enabled'],
    defaultTreatment: 'control',
  },
};

export type ExperimentConfigs = Record<Experiment, ExperimentConfig>;

export type ExperimentTreatments = Record<Experiment, ExperimentTreatmentValue>;

export const defaultExperimentTreatments = (Object.keys(experimentConfigs) as Experiment[]).reduce(
  (acc: Record<Experiment, ExperimentTreatmentValue>, key: Experiment) => ({
    ...acc,
    [key]: experimentConfigs[key].defaultTreatment,
  }),
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  {} as Record<Experiment, ExperimentTreatmentValue>
);

export interface EcsExperiments {
  readonly treatments: ExperimentTreatments;
  readonly treatmentsFromService: Partial<ExperimentTreatments>;
  readonly treatmentOverrides: Partial<ExperimentTreatments>;
}
